import { api } from './authService';
import { notifications } from './endpoints';
import { constructUrl } from '../utils/construct-url';
import { getParams } from '../utils/get-param-util';
import {
  NotificationRecord,
  TGetNotificationsParams,
  TGetNotificationsResponse,
} from '../types/notifications';

/**
 * Fetch notifications list
 */
export const getNotifications = async (
  params: TGetNotificationsParams = {}
): Promise<TGetNotificationsResponse> => {
  const query = getParams<Partial<TGetNotificationsParams>>(params);
  const url = constructUrl(notifications.getNotifications, query);
  const response = await api.get<TGetNotificationsResponse>(url);
  return response.data;
};

/**
 * Fetch a single notification by ID
 */
export const getNotificationById = async (
  id: string
): Promise<NotificationRecord> => {
  const response = await api.get<NotificationRecord>(
    notifications.getNotificationById(id)
  );
  return response.data;
};

/**
 * Resend a notification
 */
export const resendNotification = async (
  id: string,
  forceResend = false
): Promise<{ notification_id: string; resend_attempt_in: number }> => {
  const response = await api.put(notifications.resendNotification(id), {
    force_resend: forceResend,
  });
  return response.data;
};
